import { ArrowRight, Clock3 } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { conversationTemplates } from "@samklang/content";
import { Card } from "@samklang/ui";

export function TopicsScreen() {
  return (
    <section className="mx-auto w-full max-w-6xl px-5 py-8 sm:px-8">
      <div className="mb-8 max-w-2xl space-y-3">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary">Välj samtal</p>
        <h1 className="font-display text-4xl font-semibold tracking-tight">Vad vill ni prata om?</h1>
        <p className="text-lg text-foreground-muted">Välj ett kvalitetssäkrat samtal. Alla frågor är frivilliga.</p>
      </div>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {conversationTemplates.map((template) => (
          <Link key={template.id} to="/conversations/$templateId/preview" params={{ templateId: template.id }} className="rounded-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <Card padding="lg" className="flex h-full min-h-72 flex-col border-border transition-transform hover:-translate-y-0.5 hover:border-primary/40">
              <div className="flex items-start justify-between gap-4">
                <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-soft text-3xl" aria-hidden="true">{template.icon}</span>
                <ArrowRight aria-hidden="true" className="text-primary" />
              </div>
              <div className="mt-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-primary">{template.category}</p>
                <h2 className="mt-2 font-display text-2xl font-semibold">{template.title}</h2>
                <p className="mt-2 leading-relaxed text-foreground-muted">{template.description}</p>
              </div>
              <div className="mt-auto flex items-center gap-2 pt-6 text-sm font-medium text-foreground-muted"><Clock3 size={17} /> Uppskattad tid: 5 till 20 minuter · {template.questions.length} frågor i banken</div>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
}
